import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/lib/api/client';
import { Spinner } from '@/components/ui/Spinner';
import { TradeIdeaCard } from '@/components/TradeIdeaCard';
import { selectCandidates, type SymbolInsight } from '@/lib/tradeIdeas';

export function TradeIdeasPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['symbol-insights'],
    queryFn: () => analyticsApi.getSymbolInsights(),
    staleTime: 5 * 60 * 1000,
  });

  const candidates = data ? selectCandidates(data.symbols as SymbolInsight[]) : [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Trade Ideas</h1>
        <p className="text-sm text-gray-500">
          Candidate trades from symbols you've traded profitably and aren't currently in. Ideas to research — never auto-trades.
        </p>
      </div>

      {isLoading && <div className="flex justify-center py-8"><Spinner /></div>}
      {error && <div className="text-sm text-red-600">Couldn't load insights.</div>}

      {!isLoading && !error && candidates.length === 0 && (
        <div className="text-sm text-gray-500 py-8 text-center">
          No dormant-but-profitable or top-performer symbols without an open position right now.
        </div>
      )}

      <div className="space-y-3">
        {candidates.map((c) => (
          <TradeIdeaCard key={c.symbol} candidate={c} autoLoad={c.eager} />
        ))}
      </div>
    </div>
  );
}
